import ajax from 'static/script/app/data/ajax';
import _ from 'static/script/libs/underscore';
import triot from 'triot';
import { toLocalizedRiotUrl } from 'tradera-apps/syi/script/app_react/utils/language';

let service = triot.bus;

let props = {
    url: '',
    gaEvent_success: {},
    gaEvent_error: {}
};

let triggerGA = function(error) {
    let gaOptions = error ? props.gaEvent_error : props.gaEvent_success;

    // Make sure the gaOptions has been set correctly
    if (
        gaOptions.hasOwnProperty('category') &&
        gaOptions.hasOwnProperty('label') &&
        gaOptions.hasOwnProperty('action')
    ) {
        service.trigger('analytics:track-event', gaOptions);
    }
};

service.setData = function(payload) {
    props.url = payload.url;
    props.gaEvent_success = payload.gaEvent_success || {};
    props.gaEvent_error = payload.gaEvent_error || {};
};

service.sendMessage = function(payload) {
    ajax({
        url: toLocalizedRiotUrl(props.url),
        method: 'POST',
        data: payload,
        statusCode: {
            200: function(response) {
                triggerGA();
                service.trigger('data:contact-service:message-sent-success', {
                    response: response
                });
            },
            400: function(response) {
                triggerGA(true);
                service.trigger('data:contact-service:message-sent-failed', {
                    response: response
                });
            }
        }
    });
};

let lazySendMessage = _.debounce(service.sendMessage, 300); // Avoid double-clicks

export default function(payload) {
    service.setData(payload);
    service.off('ui:contact-modal:on-send');
    service.on('ui:contact-modal:on-send', lazySendMessage);
    return service;
}
